import Forward from './Forward';

/**
 * Thin wrapper for off-hours context
 * Maintains API compatibility - other components import OffHoursForward
 */
const OffHoursForward = (props) => {
  return <Forward {...props} context="offHours" />;
};

export default OffHoursForward;
